import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NotificationsService } from '../../../../services/notifications.service';
import { ToastComponent } from './toast.component';

/**
 * Conteneur global des toasts — position fixed, centre horizontalement, colle
 * au bas de l'ecran (bottom: 30px).
 *
 * Ordre d'empilement : NotificationsService ajoute chaque nouveau toast en fin
 * de tableau (`toasts()`). Ce conteneur les affiche dans cet ordre en
 * `flex-direction: column`, donc le toast le plus recent est le dernier enfant
 * du DOM = le plus proche du bord bas de l'ecran ; les toasts plus anciens
 * remontent au-dessus de lui au fur et a mesure que la pile grandit.
 *
 * A cabler une seule fois dans app.component.html, en dehors de tout garde
 * d'authentification, pour rester visible peu importe l'etat de connexion.
 */
@Component({
  selector: 'app-toast-container',
  imports: [ToastComponent],
  templateUrl: './toast-container.component.html',
  styleUrl: './toast-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  protected notifications = inject(NotificationsService);

  protected onDismiss(id: string): void {
    this.notifications.dismiss(id);
  }
}
